import { DrawerItemProps } from '@progress/kendo-react-layout'
import Translation from 'components/Translation'
import { useAppContext } from 'context/AppContext'
import { ServiceItem } from 'types/service'

export interface DayDrawerItemProps extends DrawerItemProps {
    is_header?: boolean
    start?: Date
    end?: Date
    onClose?(): void
    count?: number
    service?: ServiceItem
}
export function DayDrawerItem(props: DrawerItemProps) {
    const { translations } = useAppContext()
    return props.is_header ? (
        <li className="w-full p-6">
            <div className="flex w-full">
                <h4 className="font-display text-lg font-thin flex-1">
                    {props.text}
                </h4>
                <button
                    type="button"
                    className="text-2xl"
                    onClick={props.onClose}
                >
                    <i className="feather-x" />
                </button>
            </div>
            <div className="font-sans antialiased font-bold text-primary tracking-widest text-xs">
                {props.count} APPS
            </div>
        </li>
    ) : (
        <li className="py-3 mx-6 border-b border-gray-200 flex gap-3">
            <div className="w-20 shrink-0">
                <p className="leading-none font-display font-xs text-gray-500">
                    <small>
                        {props.start.toLocaleTimeString('default', {
                            timeStyle: 'short',
                        })}
                    </small>
                    <small className="block">-</small>
                    <small>
                        {props.end.toLocaleTimeString('default', {
                            timeStyle: 'short',
                        })}
                    </small>
                </p>
            </div>
            <div>
                <div className="font-sans font-semibold tracking-widest text-xs text-secondary uppercase antialiased mb-1  py-2">
                    {props.space_name}
                    <Translation
                        content_key={"common.type_" + (props?.service_type != undefined ? props.service_type.toLowerCase() : "appointment")}
                        render_as='span'
                        className='text-white bg-secondary text-[10px] p-1.5 font-bold uppercase border border-secondary rounded-lg ml-1.5 align-top'
                    />
                </div>
                <h4 className="font-display text-base text-primary font-thin antialiased">
                    {props.text}
                </h4>

                <small className="text-gray-400">
                    <Translation
                        content_key="slots_availability"
                        content_values={props.slots}
                        translations={{
                            slots_availability:
                                '{taken}/{max} Attendees',
                            ...translations,
                        }}
                    />
                </small>{' '}
            </div>
        </li>
    )
}
